import React from 'react';
import { Relationship } from '../api';
import { SimpleMarkdown } from './SimpleMarkdown';
import './Relationship.css';
import { DigitalItemCard } from './DigitalItemCard';
import { useMonsterTokenStyle } from '../utils/clientSettings';

export const RelationshipCard: React.FC<{ card: Relationship }> = ({ card }) => {
  const artwork = useMonsterTokenStyle();
  const partner = card.partnerInvestigatorName
    ? `Relationship with ${card.partnerInvestigatorName}${card.partnerPlayerName ? ` (${card.partnerPlayerName})` : ''}` : '';
  if (artwork === 'Digital') return <DigitalItemCard card={{ kind: 'relationship', item: card }}
    rules={<SimpleMarkdown text={card.description || ''} keyPrefix={card.id} />}
    typeLabel="" fullArtwork="" annotation={partner ? <span className="relationship-partner">{partner}</span> : undefined} annotationKey={partner}
    readableContent={partner ? <p>{partner}</p> : undefined} />;
  return (
  <div className={`card relationship-card${card.exhausted ? ' exhausted' : ''}`}>
    <div className="relationship-title">{card.name}</div>
    <div className="relationship-description">
      <SimpleMarkdown text={card.description || ''} keyPrefix={card.id} />
    </div>
    {card.partnerInvestigatorName && (
      <div className="relationship-partner">
        <b>Relationship</b> with {card.partnerInvestigatorName}
        {card.partnerPlayerName ? ` (${card.partnerPlayerName})` : ''}
      </div>
    )}
  </div>
  );
};
